import { productType, TotalPriceResult } from "@/config";

export function getFileName(fileName: string) {
    return `${import.meta.env.VITE_IMAGE_PATH}/${fileName}`;
}

export function calPriceDiscount(originalPrice: number, discountPercent: number): number {
    const discount = (originalPrice * (discountPercent ? discountPercent : 0)) / 100;
    return parseFloat(discount.toFixed(2));
}

export function calculatePriceAfterDiscount(price: number, discountPercent: number) {
    return price - (price * ((discountPercent ? discountPercent : 0) / 100));
}

export function renderTime(timeText: string, maxServiceTime: number) {
    const serviceTime = maxServiceTime ? maxServiceTime : 15
    const [hours, minutes] = timeText.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;

    if (totalMinutes <= serviceTime) return "text-gray-500";

    if (totalMinutes <= (serviceTime * 2)) return "text-[#E19D0F]";

    return "text-danger";
}

export function calculateTotalPrice(quantity: number, quantityNew: number, productItem?: productType): TotalPriceResult {
    if (!productItem) return { totalPrice: 0, totalPriceItem: 0, priceItem: 0 };

    let optionPrice = 0;
    let addonPrice = 0;

    productItem.options?.forEach(opt =>
        opt.values.forEach(v => v.isCheck && (optionPrice += Number(v.price)))
    );

    productItem.addons?.forEach(a => a.isCheck && (addonPrice += Number(a.price)));

    const totalPriceItem = Number(productItem.price) + optionPrice + addonPrice;
    const qty = productItem.options.length || productItem.addons.length ? quantity : quantityNew;

    return {
        totalPriceItem,
        priceItem: Number(productItem.price) + optionPrice,
        totalPrice: totalPriceItem * qty
    };
}

export const handleFormatInputInt = (
    event: React.FormEvent<HTMLInputElement>
) => {
    let inputText = (event.target as HTMLInputElement).value;
    inputText = inputText
        .replace(/[^0-9]/g, "") // Allow only numbers
        .replace(/\s+/g, ""); // Replace consecutive spaces with a single hyphen

    if (inputText.length > 1 && Number(inputText[0]) === 0) {
        inputText = inputText.slice(1);
    }
    const formattedInput = inputText.slice(0, 40);

    (event.target as HTMLInputElement).value = formattedInput;
};
